/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScreenerGeneratedDocument } from './ScreenerGeneratedDocument';
import {
    ScreenerGeneratedDocumentFromJSON,
    ScreenerGeneratedDocumentFromJSONTyped,
    ScreenerGeneratedDocumentToJSON,
    ScreenerGeneratedDocumentToJSONTyped,
} from './ScreenerGeneratedDocument';

/**
 * 
 * @export
 * @interface ListGeneratedReports200Response
 */
export interface ListGeneratedReports200Response {
    /**
     * 
     */
    data?: Array<ScreenerGeneratedDocument>;
}

/**
 * Check if a given object implements the ListGeneratedReports200Response interface.
 */
export function instanceOfListGeneratedReports200Response(value: object): value is ListGeneratedReports200Response {
    return true;
}

export function ListGeneratedReports200ResponseFromJSON(json: any): ListGeneratedReports200Response {
    return ListGeneratedReports200ResponseFromJSONTyped(json, false);
}

export function ListGeneratedReports200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListGeneratedReports200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(ScreenerGeneratedDocumentFromJSON)),
    };
}

export function ListGeneratedReports200ResponseToJSON(json: any): ListGeneratedReports200Response {
    return ListGeneratedReports200ResponseToJSONTyped(json, false);
}

export function ListGeneratedReports200ResponseToJSONTyped(value?: ListGeneratedReports200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(ScreenerGeneratedDocumentToJSON)),
    };
}

